import { useState, useEffect } from "react";

import { Link } from "react-router-dom";
//import DeviceInfo from "../components/DeviceInfo.jsx";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { UserCircleIcon } from "@heroicons/react/20/solid";
import logo from "../assets/logo.svg";
import useSessionStore from "../stores/sessionStore";
import authProvider from "../authProvider";

const userNavigation = [
  { name: "Settings", href: "/settings" },
  { name: "Your Profile", href: "/profile" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AppMenu() {
  // const devices = useSessionStore((state) => state.devices);
  const user = useSessionStore((state) => state.user);
  const signout = async () => {
    await authProvider.logout();
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    const updatedMenu = menu.map((item) => ({
      ...item,
      current: item.href === currentPath,
    }));
    setMenu(updatedMenu);
  }, []);

  const navigation = [{ name: "Dashboard", href: "/", current: true }];
  navigation.push({ name: "Analytics", href: "/analytics", current: false });
  // navigation.push({ name: 'Settings', href: '/settings', current: false })
  navigation.push({ name: "Support", href: "/support", current: false });

  const [menu, setMenu] = useState(navigation);

  return (
    <>
      <Disclosure
        as="nav"
        className="border-b border-cyan-300/25 bg-cyan-800 lg:border-none"
      >
        <div className="mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
          <div className="relative flex h-16 items-center justify-between lg:border-b lg:border-cyan-400/25">
            <div className="flex items-center px-2 lg:px-0">
              <div className="shrink-0">
                <img
                  alt="Fungistics Logo"
                  src={logo}
                  className="block size-8"
                />
              </div>
              <div className="hidden lg:ml-10 lg:block">
                <div className="flex space-x-4">
                  {menu.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      aria-current={item.current ? "page" : undefined}
                      className={classNames(
                        item.current
                          ? "bg-cyan-700 text-white"
                          : "text-white hover:bg-cyan-500/75",
                        "rounded-md px-3 py-2 text-sm font-medium"
                      )}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            {/*}
            <div className="flex flex-1 justify-center px-2 lg:ml-6 lg:justify-end">
              <div className="grid w-full max-w-lg grid-cols-1 lg:max-w-xs">
                <DeviceInfo devices={devices} />
              </div>
            </div>
            */}
            <div className="flex lg:hidden">
              {/* Mobile menu button */}
              <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-cyan-800 p-2 text-cyan-200 hover:bg-cyan-500/75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-cyan-800">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <Bars3Icon
                  aria-hidden="true"
                  className="block size-6 group-data-[open]:hidden"
                />
                <XMarkIcon
                  aria-hidden="true"
                  className="hidden size-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>
            <div className="hidden lg:ml-4 lg:block">
              <div className="flex items-center">
                {/* TODO: Notifications
                <button
                  type="button"
                  className="relative shrink-0 rounded-full bg-cyan-800 p-1 text-cyan-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-cyan-800"
                >
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">View notifications</span>
                  <BellIcon aria-hidden="true" className="size-6" />
                </button>
                */}

                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3 shrink-0">
                  <div>
                    <MenuButton className="relative flex rounded-full bg-cyan-800 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-cyan-800">
                      <span className="absolute -inset-1.5" />
                      <span className="sr-only">Open user menu</span>
                      <UserCircleIcon
                        aria-hidden="true"
                        className="size-8 rounded-full"
                      />
                    </MenuButton>
                  </div>
                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                  >
                    {userNavigation.map((item) => (
                      <MenuItem key={item.name}>
                        <Link
                          to={item.href}
                          className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                        >
                          {item.name}
                        </Link>
                      </MenuItem>
                    ))}
                    <MenuItem>
                      <div
                        onClick={signout}
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                      >
                        Sign out
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </div>
          </div>
        </div>

        <DisclosurePanel className="lg:hidden">
          <div className="space-y-1 px-2 pb-3 pt-2">
            {navigation.map((item) => (
              <DisclosureButton
                key={item.name}
                as={Link}
                to={item.href}
                aria-current={item.current ? "page" : undefined}
                className={classNames(
                  item.current
                    ? "bg-cyan-700 text-white"
                    : "text-white hover:bg-cyan-500/75",
                  "block rounded-md px-3 py-2 text-base font-medium"
                )}
              >
                {item.name}
              </DisclosureButton>
            ))}
          </div>
          <div className="border-t border-cyan-700 pb-3 pt-4">
            <div className="flex items-center px-5">
              <div className="shrink-0">
                <UserCircleIcon
                  aria-hidden="true"
                  className="size-10 rounded-full text-cyan-200"
                />
              </div>
              <div className="ml-3">
                <div className="text-sm font-medium text-cyan-300">
                  {user.email}
                </div>
              </div>
              {/* TODO: Notifications
              <button
                type="button"
                className="relative ml-auto shrink-0 rounded-full bg-cyan-800 p-1 text-cyan-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-cyan-800"
              >
                <span className="absolute -inset-1.5" />
                <span className="sr-only">View notifications</span>
                <BellIcon aria-hidden="true" className="size-6" />
              </button>
          */}
            </div>
            <div className="mt-3 space-y-1 px-2">
              {userNavigation.map((item) => (
                <DisclosureButton
                  key={item.name}
                  as={Link}
                  to={item.href}
                  className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-cyan-500/75"
                >
                  {item.name}
                </DisclosureButton>
              ))}

              <DisclosureButton
                onClick={signout}
                className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-cyan-500/75"
              >
                Sign out
              </DisclosureButton>
            </div>
          </div>
        </DisclosurePanel>
      </Disclosure>
    </>
  );
}
